module.exports = __webpack_public_path__ + "static/media/gps-center.4cc9b8af.svg";